module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "invite-to-game"
    }
  }, [_c('form', [(_vm.fetchingGame) ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.showSuccessMessage) ? [_c('div', {
    staticClass: "validation-messages friendly"
  }, [_vm._v("Invitation Successfully Sent")])] : _vm._e(), _vm._v(" "), (!_vm.fetchingGame && !_vm.showSuccessMessage) ? [(_vm.gameFound && _vm.isLoggedIn) ? _c('div', [_c('h2', [_vm._v("\n                    Request to Join\n                    "), _c('router-link', {
    attrs: {
      "to": ("/Game/" + (_vm.foundGame.stringUrl))
    }
  }, [_c('i', {
    staticClass: "fas fa-gamepad"
  }), _vm._v(" " + _vm._s(_vm.foundGame.alias))])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "position-titles"
    }
  }, [_vm._v("Position Title(s)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.positionTitles),
      expression: "formData.positionTitles"
    }],
    attrs: {
      "id": "position-titles",
      "type": "text",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.formData.positionTitles)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.positionTitles = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('span', [_vm._v("Position Types")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox-container"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.selectedPositions),
      expression: "formData.selectedPositions"
    }],
    attrs: {
      "type": "checkbox",
      "value": "Designer",
      "disabled": _vm.isSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Designer") > -1 : (_vm.formData.selectedPositions)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.selectedPositions,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Designer",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.selectedPositions = $$c
        }
      }
    }
  }), _c('span', [_vm._v("Designer")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.selectedPositions),
      expression: "formData.selectedPositions"
    }],
    attrs: {
      "type": "checkbox",
      "value": "Artist",
      "disabled": _vm.isSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Artist") > -1 : (_vm.formData.selectedPositions)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.selectedPositions,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Artist",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.selectedPositions = $$c
        }
      }
    }
  }), _c('span', [_vm._v("Artist")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.selectedPositions),
      expression: "formData.selectedPositions"
    }],
    attrs: {
      "type": "checkbox",
      "value": "Programmer",
      "disabled": _vm.isSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Programmer") > -1 : (_vm.formData.selectedPositions)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.selectedPositions,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Programmer",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.selectedPositions = $$c
        }
      }
    }
  }), _c('span', [_vm._v("Programmer")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.selectedPositions),
      expression: "formData.selectedPositions"
    }],
    attrs: {
      "type": "checkbox",
      "value": "Musician",
      "disabled": _vm.isSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Musician") > -1 : (_vm.formData.selectedPositions)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.selectedPositions,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Musician",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.selectedPositions = $$c
        }
      }
    }
  }), _c('span', [_vm._v("Musician")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.selectedPositions),
      expression: "formData.selectedPositions"
    }],
    attrs: {
      "type": "checkbox",
      "value": "SFX Artist",
      "disabled": _vm.isSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "SFX Artist") > -1 : (_vm.formData.selectedPositions)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.selectedPositions,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "SFX Artist",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.selectedPositions = $$c
        }
      }
    }
  }), _c('span', [_vm._v("SFX Artist")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.selectedPositions),
      expression: "formData.selectedPositions"
    }],
    attrs: {
      "type": "checkbox",
      "value": "Writer",
      "disabled": _vm.isSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Writer") > -1 : (_vm.formData.selectedPositions)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.selectedPositions,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Writer",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.selectedPositions = $$c
        }
      }
    }
  }), _c('span', [_vm._v("Writer")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.selectedPositions),
      expression: "formData.selectedPositions"
    }],
    attrs: {
      "type": "checkbox",
      "value": "Producer",
      "disabled": _vm.isSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Producer") > -1 : (_vm.formData.selectedPositions)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.selectedPositions,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Producer",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.selectedPositions = $$c
        }
      }
    }
  }), _c('span', [_vm._v("Producer")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.selectedPositions),
      expression: "formData.selectedPositions"
    }],
    attrs: {
      "type": "checkbox",
      "value": "Tester",
      "disabled": _vm.isSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Tester") > -1 : (_vm.formData.selectedPositions)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.selectedPositions,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Tester",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.selectedPositions = $$c
        }
      }
    }
  }), _c('span', [_vm._v("Tester")])])])]), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('div', {
    staticClass: "validation-messages error"
  }, _vm._l((_vm.formErrors), function(error) {
    return _c('span', [_vm._v(_vm._s(error))])
  })) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitRequest($event)
      }
    }
  }, [_vm._v("Send Request")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.gameFound || !_vm.isLoggedIn) ? _c('div', [_c('h2', [_vm._v("Error")]), _vm._v(" "), (!_vm.gameFound && _vm.isLoggedIn) ? _c('span', [_vm._v("Game Project Not found")]) : _vm._e(), _vm._v(" "), (!_vm.isLoggedIn) ? _c('span', [_vm._v("You must be logged in to do this")]) : _vm._e()]) : _vm._e()] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d0c9480e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/InvitationRequests/RequestToJoinForm.vue
// module id = 917
// module chunks = 2